import { useDatabaseObjectData } from 'reactfire';

import { Game } from '../shared/firebaseTypes';
import useGameRef from './useGameRef';

const useGameProperty = <K extends keyof Game>(key: K) =>
  useDatabaseObjectData<Game[K]>(useGameRef().child(key));

export default useGameProperty;
